/*
 svgInject - v1.0.0
 Plugin for replacing img-tags with SVG content
 by Christoph Dörfel <christoph.doerfel@yooapps.com>
 
 Dual licensed under MIT and GPL.
 */
;(function (window, document, namespace, undefined) {
	
	var SvgInject = (function () {
		/**
		 *
		 * @param {string|Node|NodeList} selector
		 * @param {Function} [options] (Optional)
		 * @returns {SvgInject}
		 * @constructor
		 */
		function SvgInject(selector, options) {
			// Return a new instance if called without the 'new' keyword.
			if (!(this instanceof SvgInject)) {
				return new SvgInject(selector, options);
			}
			
			// Element is a string containing one or more CSS selectors separated by commas.
			if (typeof selector === 'string') {
				this.elements = document.querySelectorAll(selector);
			}
			// Element is an array of DOM elements.
			else if (selector.length) {
				this.elements = selector;
			// Element is a single DOM element.
			} else {
				this.elements = [selector];
			}
			
			this.callback = options;
			this._cache = SvgInject._cache;
			this.init();
		}
		
		SvgInject._cache = new Map();
		
		SvgInject._injectCount = 0;
		
		SvgInject.prototype = {
			init: function () {
				var promises = [];
				for (var i = 0; i < this.elements.length; i++) {
					// this.elements[i].style.visibility = 'hidden';
					promises.push(this.injectSvg(this.elements[i], this.callback));
				}
				this._promiseAll = Promise.all(promises);
			},
			injectSvg: function (el, callback) {
				var url = el.getAttribute('data-src') || el.getAttribute('src'),
					promise;
				
				if (!this._cache.has(url))
				{
					// We add an entry to the cache with the given image url
					promise = new Promise(function(resolve, reject) {
						var request = new Request(url, {
							method: 'GET',
							headers: new Headers({
								'Content-Type': 'text/xml'
							})
						});
						
						fetch(request).then(function(response) {
							response.text().then(function (html) {
								var d = document.createElement('div');
								d.innerHTML = html;
								var svg = d.querySelector('svg');
								if (svg !== null) {
									resolve(svg);
								} else {
									reject('Unable to parse SVG');
								}
							});
						}).catch(function (error) {
							reject(error);
						});
					});
					
					this._cache.set(url, promise);
				}
				else
				{
					promise = this._cache.get(url);
				}
				
				var fn = this.replaceImgWithSVG.bind(this);
				
				// When the entry is loaded, the image gets replaced by the clone of the loaded svg
				return promise.then(function(svg){
					var clonedSvg = svg.cloneNode(true);
					fn(el, clonedSvg, url, callback);
					return clonedSvg;
				});
			},
			replaceImgWithSVG: function (el, svg, url, callback) {
				// Check if element has already been replaced in the DOM
				// @todo might cause issues when operating on dynamically created elements.
				if (el.parentNode === null) {
					if (typeof callback === 'function') {
						callback();
					}
					return;
				}
				
				var imgId = el.getAttribute('id'),
					imgTitle = el.getAttribute('title'),
					imgClass = el.getAttribute('class'),
					imgStyle = el.getAttribute('style'),
					dimensions = {
						w: el.getAttribute('width'),
						h: el.getAttribute('height')
					},
					imgData = [],
					injectCount = ++SvgInject._injectCount
				;
				
				for (var att, i = 0, atts = el.attributes, n = atts.length; i < n; i++) {
					att = atts[i];
					if (att.nodeName.startsWith('data-')) {
						imgData[atts.nodeName] = att.nodeValue;
					}
				}
				
				if (imgId !== null && imgId.length !== 0) {
					svg.setAttribute('id', imgId);
				}
				
				if (imgTitle !== null && imgTitle.length !== 0) {
					svg.setAttribute('title', imgTitle);
				}
				
				svg.setAttribute('class', (imgClass !== null && imgClass.length > 0 ? imgClass + ' ' : '') + 'replaced-svg');
				
				if (imgStyle !== null && imgStyle.length !== 0) {
					svg.setAttribute('style', imgStyle);
				}
				
				for (var nodeName in imgData) {
					if (imgData.hasOwnProperty(nodeName)) {
						svg.setAttribute(nodeName, imgData[nodeName]);
					}
				}
				
				if (url !== null && url.length !== 0) {
					svg.setAttribute('data-url', url);
				}
				
				// Make sure any internally referenced clipPath ids and their
				// clip-path references are unique.
				//
				// This addresses the issue of having multiple instances of the
				// same SVG on a page and only the first clipPath id is referenced.
				//
				// Browsers often shortcut the SVG Spec and don't use clipPaths
				// contained in parent elements that are hidden, so if you hide the first
				// SVG instance on the page, then all other instances lose their clipping.
				// Reference: https://bugzilla.mozilla.org/show_bug.cgi?id=376027
				
				// Handle all defs elements that have iri capable attributes as defined by w3c: http://www.w3.org/TR/SVG/linking.html#processingIRI
				// Mapping IRI addressable elements to the properties that can reference them:
				var iriElementsAndProperties = {
					'clipPath': ['clip-path'],
					'color-profile': ['color-profile'],
					'cursor': ['cursor'],
					'filter': ['filter'],
					'linearGradient': ['fill', 'stroke'],
					'marker': ['marker', 'marker-start', 'marker-mid', 'marker-end'],
					'mask': ['mask'],
					'pattern': ['fill', 'stroke'],
					'radialGradient': ['fill', 'stroke']
				};
				
				var element, elementDefs, properties, currentId, newId;
				Object.keys(iriElementsAndProperties).forEach(function (key) {
					element = key;
					properties = iriElementsAndProperties[key];
					
					elementDefs = svg.querySelectorAll('defs ' + element + '[id]');
					for (var i = 0, elementsLen = elementDefs.length; i < elementsLen; i++) {
						currentId = elementDefs[i].id;
						newId = currentId + '-' + injectCount;
						
						// All of the properties that can reference this element type
						var referencingElements;
						Array.prototype.forEach.call(properties, function (property) {
							// :NOTE: using a substring match attr selector here to deal with IE "adding extra quotes in url() attrs"
							referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId + '"]');
							for (var j = 0, referencingElementLen = referencingElements.length; j < referencingElementLen; j++) {
								referencingElements[j].setAttribute(property, 'url(#' + newId + ')');
							}
						});
						
						elementDefs[i].id = newId;
					}
				});
				
				// Remove any unwanted/invalid namespaces that might have been added by SVG editing tools
				svg.removeAttribute('xmlns:a');
				
				var ow = parseFloat(svg.getAttribute('width'));
				var oh = parseFloat(svg.getAttribute('height'));
				
				if (dimensions.w && dimensions.h) {
					svg.setAttribute('width', dimensions.w);
					svg.setAttribute('height', dimensions.h);
				} else if (dimensions.w) {
					svg.setAttribute('width', dimensions.w);
					svg.setAttribute('height', ((oh / ow) * dimensions.w) + '');
				} else if (dimensions.h) {
					svg.setAttribute('height', dimensions.h);
					svg.setAttribute('width', ((ow / oh) * dimensions.h) + '');
				}
				
				el.replaceWith(svg);
				
				var script = svg.querySelector('script');
				if (script) {
					try {
						var js = new Function(script.textContent);
						js();
					} catch(e) {}
				}
				
				el = null;
				
				if (typeof callback === 'function') {
					callback();
				}
			},
			'then': function (fn) {
				return this._promiseAll.then(fn);
			},
			'catch': function (fn) {
				return this._promiseAll.catch(fn);
			},
		};
		
		return SvgInject;
	}());
	
	window[namespace] = SvgInject;
	
})(window, document, 'SvgInject');